import FluxUtils from 'flux/utils';
import Immutable from 'immutable';

import AboutActions from 'sharedreact/actions/AboutActions';
import askConfirmation from 'sharedreact/components/askConfirmation';
import AboutStore from 'sharedreact/stores/AboutStore';
import SettingsStore from 'sharedreact/stores/SettingsStore';
import { translate } from 'sharedreact/utils/LanguageSupport';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';

import AgentsActions from 'workspaces/launcher/actions/AgentsActions';
import AgentsTab from 'workspaces/launcher/components/admin/AgentsTab';
import Agent from 'workspaces/launcher/data/Agent';
import AgentsStore from 'workspaces/launcher/stores/AgentsStore';
import asFunctional from 'sharedreact/components/asFunctional';

type Props = {
  index: number,
  activeTab: number,
};

type State = ConstructorParameters<typeof AgentsTab>[0];

function getStores () {
  return [
    SettingsStore,
    AgentsStore,
    AboutStore
  ];
}

function handleLoad () {
  AboutActions.fetch();
  AgentsActions.fetch();
}

function handleRemoveAgent (agent: Agent) {
  const messageInfo: string = agent.status === 'connected' ? translate('launcher.admin.agents.remove.confirminfo') : '';
  askConfirmation('agents_remove',
    translate('launcher.admin.agents.remove.title'),
    translate('launcher.admin.agents.remove.confirmmessage', agent.name),
    messageInfo)
  .then(() => AgentsActions.remove(Immutable.List([agent.id])), () => {});
}

function _getVersionId (versionString: string): string {
  const items = versionString.split(' ');
  const buildIdx = items.findIndex(item => item === 'Build');
  return items[0] + '.' + items[buildIdx+1];
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  const versionString = AboutStore.getVersionInfo();
  const versionId = _getVersionId(versionString);

  return {
    index: props.index,
    activeTab: props.activeTab,
    language: SettingsStore.getLanguage(),
    agents: AgentsStore.getItems(),
    selection: AgentsStore.getSelection(),
    sortOrder: AgentsStore.getSortOrder(),
    onSortOrderChange: AgentsActions.setSortOrder,
    onRemoveAgent: handleRemoveAgent,
    onLoad: handleLoad,
    isFetching: AgentsStore.isFetching(),
    serverVersion: versionId
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(AgentsTab),
  getStores,
  calculateState,
  { withProps: true }
);
